import { UnknownError } from '@dialectlabs/sdk';
import { DisconnectedFromChainError, InsufficientFundsError, NotSignedError, SolanaError, } from '../errors';
export class AccountNotFoundError extends SolanaError {
    constructor(details) {
        super(AccountNotFoundError.name, 'Error', 'Account does not exist', details);
    }
}
AccountNotFoundError.matchers = ['Account does not exist'];
export class AccountAlreadyExistsError extends SolanaError {
    constructor(details) {
        super(AccountAlreadyExistsError.name, 'Error', 'Account already exists', details);
    }
}
AccountAlreadyExistsError.matchers = ['already in use'];
export async function withErrorParsing(promise) {
    try {
        return await promise;
    }
    catch (e) {
        const err = e;
        throw parseError(err);
    }
}
function parseError(error) {
    const message = error.message;
    const logs = (('logs' in error && error.logs) || []).join('');
    if (!InsufficientFundsError.matchers.some((it) => message.match(it))) {
        if (DisconnectedFromChainError.matchers.some((it) => message.match(it))) {
            throw new DisconnectedFromChainError([error]);
        }
        if (AccountAlreadyExistsError.matchers.some((it) => logs.match(it))) {
            throw new AccountAlreadyExistsError([error]);
        }
        if (AccountNotFoundError.matchers.some((it) => message.match(it))) {
            throw new AccountNotFoundError([error]);
        }
        if (NotSignedError.matchers.some((it) => message.match(it))) {
            throw new NotSignedError([error]);
        }
        throw new UnknownError([error]);
    }
    else {
        throw new InsufficientFundsError([error]);
    }
}
//# sourceMappingURL=solana-messaging-errors.js.map